module.exports = __webpack_public_path__ + "img/no.6becf616.png";